import { setupVideoContainer } from './setupVideoContainer';
import { setupVideoElement } from './setupVideoElement';
import { setupControls } from './setupControls';
import { setupVideoEventHandlers } from './setupVideoEventHandlers';

/**
 * Creates and initializes a Dash player, setting it up with the appropriate video source.
 * @param {string} trailerId - The ID or URL of the trailer to be played.
 * @param {HTMLElement} mediaSection - The media section element where the video player will be appended.
 */
export function createAndPlayPlayer(trailerId, mediaSection) {

  const videoContainer = setupVideoContainer();
  const videoElement = setupVideoElement(mediaSection, trailerId);

  if (!trailerId) return;

  setupControls(videoElement);
  setupVideoEventHandlers(videoElement, videoContainer);
}
